module.exports = __webpack_public_path__ + "static/media/left-direction-img.183fb271.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-direction-img.svg
// module id = 907
// module chunks = 0